import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { SiilaTranslationService } from "../../../core/services/siila-translation.service";
import { MetaTagService } from "../../services/meta-tag.service";

@Component({
  selector: "app-page-not-found",
  templateUrl: "./page-not-found.component.html",
  styleUrls: ["./page-not-found.component.scss"]
})
export class PageNotFoundComponent implements OnInit {
  wrongRoute: string;
  homeUrl: string;

  constructor(
    private location: Location,
    private metaSrv: MetaTagService,
    private siilaTranslationService: SiilaTranslationService
  ) {}

  ngOnInit(): void {
    this.metaSrv.setPrerenderStatusCode(404);

    // Overwrite the meta `app.component` derived from the requested URL: a page
    // answering 404 must not self-canonicalize onto the URL that failed, nor
    // carry that URL's hreflang alternates.
    this.metaSrv.setNotFoundTags();

    // `buildLocalizedPath("/")` is "" on the default language, which renders an
    // `href=""` that base-ignoring crawlers resolve to this 404 page itself.
    this.homeUrl = this.siilaTranslationService.buildLocalizedPath("/") || "/";

    if (window.history.state && window.history.state.badURL) {
      this.wrongRoute = window.history.state.badURL;
    } else {
      this.wrongRoute = window.location.href;
    }

    this.location.go("/404");
  }
}
